import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API });

export const fetchProduct = async () => (await http.get("/product")).data;

export const fetchCart = async (cartId) => (await http.get(`/cart/${cartId}`)).data;

export const addToCart = async ({ cart_id, product_id, quantity }) =>
  (await http.post("/cart/add", { cart_id, product_id, quantity })).data;

export const updateItem = async (cartId, itemId, quantity) =>
  (await http.patch(`/cart/${cartId}/item/${itemId}`, { quantity })).data;

export const removeItem = async (cartId, itemId) =>
  (await http.delete(`/cart/${cartId}/item/${itemId}`)).data;

export const createCheckout = async ({ cart_id, origin_url, shipping }) =>
  (await http.post("/payments/checkout", { cart_id, origin_url, shipping })).data;

export const getCheckoutStatus = async (sessionId) =>
  (await http.get(`/payments/status/${sessionId}`)).data;
